@if(showOnlyQrCode) {
<div class="modal-placeholder"></div>
} @else {
<div mat-dialog-title class="dialog-title" translate>MAIN_MENU_FILE-SHARE</div>
<div class="dialog-subtitle-row">
    <mat-icon>{{shellStateService.getTypeIcon(docType+'')}}</mat-icon>
    <div class="dialog-subtitle" [matTooltip]="docName">{{docName}}</div>
</div>

<div mat-dialog-content class="main-content">
    @if (isMapMine) {
    <div class="add-user-container">
        <div class="email-input-container">
            <mat-form-field class="email-input" appearance="outline">
                <mat-label translate>SHAREDOC_ADD_USER</mat-label>
                <input matInput #addUserNameField [matAutocomplete]="auto" [disabled]="!isMapMine" type="text"
                    spellcheck="false" (keyup)="onAddUserKeyUp($event)" (change)="onAddUserChange($event)" />
                <mat-autocomplete #auto="matAutocomplete" (optionSelected)="optionSelected($event.option.value)">
                    @if(shareEmailsFreq.length > 0) {
                    <mat-optgroup label="{{'SHAREGROUP_FREQ' | translate}}">
                        @for (email of shareEmailsFreq; track email) {
                        <mat-option [value]="email">{{email}}</mat-option>
                        }
                    </mat-optgroup>
                    }
                    @if (shareEmailsGroup.length > 0) {
                    <mat-optgroup label="{{'SHAREGROUP_GROUP' | translate}}">
                        @for (email of shareEmailsGroup; track email) {
                        <mat-option [value]="email">{{email}}</mat-option>
                        }
                    </mat-optgroup>
                    }
                </mat-autocomplete>
            </mat-form-field>
        </div>
        <div class="email-share-type-container">
            <mat-form-field class="share-type-input" appearance="outline">
                <mat-select cdkFocusInitial [disabled]="!isMapMine" [(ngModel)]="shareType">
                    @for (s of addShareTypesOptions; track s) {
                    <mat-option [value]="s.value">
                        <mat-icon class="option-icon">{{s.icon}}</mat-icon>
                        {{s.name}}
                    </mat-option>
                    }
                </mat-select>
            </mat-form-field>
            <button mat-flat-button [disabled]="!isMapMine" (click)="addUser()">
                {{"SHARE_RECENT" | translate}}
            </button>
        </div>
    </div>
    }
    <!--<mat-divider style="width: 100%;"></mat-divider>-->
    <div class="section-title" translate>SHAREDOC_USERSLIST</div>
    <div [ngClass]="{'users-list-min-height': loadUsersList.length >= 2}" class="users-list-container">
        @for (user of loadUsersList; track user) {
        <div class="user-list-item">
            @if (user.picture) {
            <img class="user-list-image" [src]="user.picture" />
            } @else {
            <div class="user-list-avatar-container">
                <div class="avatar"> {{shellStateService.getInitials(user.name)}}</div>
            </div>
            }
            <div class="user-list-details-container">
                <div class="user-list-details-first-row">
                    <div class="users-list-name">{{user.name}}</div>
                </div>
                <div class="user-list-details-second-row">
                    <div class="users-list-email">{{user.email}}</div>
                </div>
            </div>
            <div class="user-list-tools-container">
                @if (user.isOwner){
                <span class="users-list-owner" translate>SHAREDOC_OWNER</span>
                } @else {
                <mat-select [disabled]="!isMapMine" class="users-list-type" [(value)]="user.internalRole">
                    @for (s of editShareTypesOptions; track s) {
                    <mat-option class="share-option" [value]="s.value">{{s.name}}</mat-option>
                    }
                </mat-select>
                }
            </div>
        </div>
        }
    </div>
    <mat-divider style="width: 100%;"></mat-divider>
    <span class="section-title" translate>SHAREDOC_PUBLIC</span>
    @if (publicShareType === publicShareTypesOptions[0].value) {
    <div class="public-share-description" translate>
        <mat-icon class="public-share-icon">{{publicShareTypesOptions[0].icon}}</mat-icon>
        PUBLIC_SHARE_LIMIT_ONLY_PERMISSION_DESCRIPTION
    </div>
    }
    @if (publicShareType === publicShareTypesOptions[1].value) {
    <div class="public-share-description" translate>
        <mat-icon class="public-share-icon">{{publicShareTypesOptions[1].icon}}</mat-icon>
        PUBLIC_SHARE_VIEW_ONLY_PERMISSION_DESCRIPTION
    </div>
    }
    @if(publicShareTypesOptions.length > 2 && publicShareType === publicShareTypesOptions[2].value) {
    <div class="public-share-description" translate>
        <mat-icon class="public-share-icon">{{publicShareTypesOptions[2].icon}}</mat-icon>
        PUBLIC_SHARE_EDIT_PERMISSION_DESCRIPTION
    </div>
    }
    <div class="public-share-container">
        <mat-form-field appearance="outline">
            <mat-select [disabled]="!isMapMine" [(ngModel)]="publicShareType">
                @for (s of publicShareTypesOptions; track s) {
                <mat-option [value]="s.value">
                    <mat-icon class="option-icon">{{s.icon}}</mat-icon>
                    {{s.name}}
                </mat-option>
                }
            </mat-select>
        </mat-form-field>
    </div>

    <mat-divider style="width: 100%;"></mat-divider>
    <div class="action-buttons-container">
        @if (!showOnlyQrCode) {
        <button mat-stroked-button matTooltip="{{'SHARE_COPY_LINK' | translate}}" (click)="copyLink(true)">
            <mat-icon>insert_link</mat-icon>
            {{"SHARE_COPY_LINK" | translate}}
        </button>
        }
        <button mat-stroked-button matTooltip="{{'SHARE_LINK_QRCODE' | translate}}" (click)="showQRCodeAndCopyLink()">
            <mat-icon>qr_code</mat-icon>
            {{"SHARE_LINK_QRCODE" | translate}}
        </button>
        @if (showClassroom && authenticationService.isGoogleUser() || authenticationService.linkedWithGoogle() ){
        <button mat-icon-button matTooltip="{{'MAIN_TOOLBAR_SHARE_CLASSROOM' | translate}}" (click)="shareClassroom()">
            <mat-icon svgIcon="classroomIcon"></mat-icon>
        </button>
        }
    </div>
</div>
}

@if(!showOnlyQrCode) {
<button class="close-button" mat-icon-button [mat-dialog-close]="true">
    <mat-icon>close</mat-icon>
</button>
}